import { Frame, Layout, Page, LegacyCard, List, Banner, TextContainer, Button, ChoiceList, TextField} from "@shopify/polaris";
import { initial } from "lodash";
import { useEffect, useState } from "react";
import Api from '../../helpers/api';
import {Redirect} from '@shopify/app-bridge/actions';
import { useAppBridge } from "@shopify/app-bridge-react";

const ChargeCustomer = props => {

    const app = useAppBridge();
    const redirect = Redirect.create(app);
    const [customer, setCustomer] = useState(null);
    const [draftOrder, setDraftOrder] = useState(null);
    const [charge, setCharge] = useState(null);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [chargeValue, setChargeValue] = useState("0");

    const changePaymentMethod = value => {
        let customerId = null;
        value = value[0];

        paymentMethods.forEach(method => {
            if (value == method.id)
                customerId = method.stripe_customer_id;
        });

        setCharge({
            ...charge,
            payment_method_id: value,
            payment_method_customer_id: customerId,
        });
    }

    const init = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const draftOrderId = urlParams.get('id');

        let draftOrder = await Api.getDraftOrder( draftOrderId );
        setDraftOrder(draftOrder.data.draft_order);
        setCustomer(draftOrder.data.customer);
        setChargeValue(draftOrder.data.draft_order.total_price)

        const chargeData = {
            'customer_id': draftOrder.data.customer.id,
            'draft_order_id': draftOrder.data.draft_order.id,
            'payment_method_id': null,
            'payment_method_customer_id': null,
        };

        let paymentMethods = await Api.getPaymentMethods(draftOrder.data.customer.id);
        setPaymentMethods(paymentMethods.data);
        let id = paymentMethods.data.length > 0 ? paymentMethods.data[0].id : null;
        let customerId = paymentMethods.data.length ? paymentMethods.data[0].stripe_customer_id : null;

        if (draftOrder.data.customer.card)
            paymentMethods.data.forEach(method => {
                if (method.stripe_customer_id == draftOrder.data.customer.card.stripe_customer_id)
                {
                    id = method.id;
                    customerId = method.stripe_customer_id;
                }
            });

        if (draftOrder.data.address && draftOrder.data.address.card)
            paymentMethods.data.forEach(method => {
                if (method.stripe_customer_id == draftOrder.data.address.card.stripe_customer_id)
                {
                    id = method.id;
                    customerId = method.stripe_customer_id;
                }
            });

        chargeData.payment_method_id = id;
        chargeData.payment_method_customer_id = customerId;

        setCharge(chargeData);
        setLoaded (true);
    }

    useEffect( () => {
        init();
    }, []);

    const redirectToDraftOrder = () => {
        redirect.dispatch(Redirect.Action.ADMIN_PATH, `/draft_orders/${draftOrder.id}`);
    }

    const chargeCreditCard = () => {
        setLoading(true);
        Api.chargeCreditCard( {
            ... charge,
            charge_value: chargeValue
        } )
            .then ( response => {
                redirectToDraftOrder();
                setLoading(false);
            })
            .catch((error) => {
                if (error?.response?.data?.message) {
                    alert(error.response.data.message);
                } else if (error?.response?.data?.error) {
                    alert(error?.response?.data?.error);
                } else {
                    alert("There was undefined error while trying to charge for that order");
                }
            })
            .finally(() => setLoading(false));
    }

    return (
        <Frame>
            {loaded && draftOrder && customer && (
                <Page title={`Charge Order ${draftOrder.name}`} primaryAction={
                    <Button
                        onClick={chargeCreditCard}

                        loading={loading}
                        disabled={(charge?.payment_method_id == null && customer.additional_data?.payment_methods == null) || draftOrder.status == 'completed'}
                        variant="primary">Charge Credit Card</Button>
                } breadcrumbs={[{
                    content: "Back to Draft Order",
                    onAction() {
                        redirectToDraftOrder();
                    }
                }]}>
                    <Layout>
                        { draftOrder.status == 'completed' && (
                            <Layout.Section>
                            <Banner
                                title="This draft order is already paid"
                                tone="warning"
                                action={{content: 'Back to Draft Order', onAction: () => {
                                    redirectToDraftOrder();
                                }}}
                                >
                                <TextContainer>
                                    <p>This order cannot be charged because it is alrady paid.</p>
                                </TextContainer>
                                </Banner>
                            </Layout.Section>
                        )}
                        <Layout.Section>
                            <LegacyCard sectioned title="Order Information">
                                <List type="bullet">
                                    <List.Item><strong>Draft Order</strong>: {draftOrder.name}</List.Item>
                                    <List.Item><strong>Total Amount</strong>: ${draftOrder.total_price}</List.Item>
                                    <List.Item><strong>Outstanding Amount</strong>: ${draftOrder.total_price}</List.Item>
                                    <List.Item><strong>Customer</strong>: {customer.additional_data.last_name } {customer.additional_data.last_name }</List.Item>
                                </List>
                            </LegacyCard>
                        </Layout.Section>
                        { charge?.payment_method_id != null && paymentMethods ? (
                            <Layout.Section>
                                <LegacyCard sectioned title="Select a Credit Card">
                                    <ChoiceList
                                        disabled={draftOrder.status == 'completed'}
                                        title="Credit Cards"
                                        choices={ paymentMethods.map (method => {
                                            return {
                                                label: `${method.brand} - ${method.last_four} - Exp: ${method.exp_month}/${method.exp_year}`,
                                                value: method.id
                                            }
                                        })}
                                        selected={charge.payment_method_id}
                                        onChange={changePaymentMethod}
                                    />
                                    <TextField
                                        label={"Charge Value"}
                                        type={"number"}
                                        step={1.0}
                                        value={chargeValue}
                                        min={1}
                                        max={draftOrder.total_price}
                                        onChange={(val) => {
                                            if (parseFloat(val) >= parseFloat(draftOrder.total_price)) {
                                                setChargeValue(draftOrder.total_price);
                                            } else if (parseFloat(val) < 1) {
                                                setChargeValue("1");
                                            } else {
                                                setChargeValue(val);
                                            }
                                        }}
                                       />
                                </LegacyCard>
                            </Layout.Section>
                        ) : (
                            <Layout.Section>
                            <Banner
                                title="No credit card added to this customer"
                                tone="warning"
                                >
                                <TextContainer>
                                    <p>The customer you are charging doesn't have a credit card added to his profile. Please add a credit card first.</p>
                                </TextContainer>
                                </Banner>
                            </Layout.Section>
                        ) }
                    </Layout>
                </Page>
            )}
        </Frame>
    );
}

export default ChargeCustomer;
